import { IChatHeader } from '../../types/chatHeader';
import { TOffer } from '../../types/offer';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TNewChat } from '../../utils/addNewChat';

export enum EOpenedChatsTypes {
  Add = 'openedChats/add',
  Clear = 'openedChats/clear',
  Delete = 'openedChats/delete',
}

export type TAddOpenedChatPayload = {
  chatId: string;
  offer?: TOffer;
  newChat: TNewChat;
  header?: IChatHeader;
};

export type TOpenedChatsActions =
  | ITypedReduxAction<EOpenedChatsTypes.Clear>
  | ITypedReduxAction<EOpenedChatsTypes.Add, TAddOpenedChatPayload>
  | ITypedReduxAction<EOpenedChatsTypes.Delete, string>;
